module.exports = __webpack_public_path__ + "static/media/galdinsLose_100_250.36ef18a4.png";